export const HELLO_SLEEPIO_EMAIL_ADDRESS = 'hello@sleepio.com';
export const HELLO_DAYLIGHT_EMAIL_ADDRESS = 'hello@trydaylight.com';
